export const BASE_URL = 'https://hub.peppercontent.dev/platform'
export const API_GATEWAY_BASE_URL = 'https://hub.peppercontent.dev'
export const EDITOR_SERVICE_BASE_URL='https://hub.peppercontent.dev/pepper-editor-service'
export const USER_SERVICE_BASE_URL = 'https://hub.peppercontent.dev/user-service'
export const PAYMENT_SERVICE_BASE_URL = 'https://hub.peppercontent.dev/payment-service-qa'
export const SEO_SERVICE_BASE_URL = 'https://hub.peppercontent.dev/seo-service'
export const KNOWLEDGE_BASE_BASE_URL = 'https://hub.peppercontent.dev/knowledge-base-service'
export const ATLAS_SERVICE_BASE_URL = 'https://hub.peppercontent.dev/atlas-service'
export const SPOTDRAFT_URL = 'https://app.qa.dev.spotdraft.com/auth/embed-contract'
export const GET_STREAM_TOKEN = '5g9npp3h462d'
export const CREATE_PROJECT_BASE_URL = 'https://versions.peppercontent.dev'
export const REACT_APP_LOOM_API_KEY = '05d592cf-ed8b-4db1-b070-249d24f6c9a6'
export const REACT_APP_UNSPLASH_KEY = '-J2WKws-0lUDfWyqcpC5El8sXM0-agvibTqrlDfteto'
export const SOCKET_URL = 'wss://hub.peppercontent.dev'
export const ELASTIC_SERVICE_VERSION = 'unknown'
export const GOOGLE_CLIENT_ID = '726431378791-9ge84j8475ev2sh8j9esrhfc8msu1jhp.apps.googleusercontent.com'
